export default __webpack_public_path__ + "static/engine-7b643e26767102985b5cd6b84d0097e3.jpg";